import { useEffect, useState } from "react";
import { Responsive, WidthProvider } from "react-grid-layout";
import 'react-grid-layout/css/styles.css'
import 'react-resizable/css/styles.css'
//icons material
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import DriveFileRenameOutlineIcon from '@mui/icons-material/DriveFileRenameOutline';
//Material ui
import {
    Box, IconButton, makeStyles, Tooltip
} from '@material-ui/core';
import { listComponent, OPTIONS } from "./helpers";

const ResponsiveReactGridLayout = WidthProvider(Responsive);

const useStyles = makeStyles(theme => ({
    boxes: {
        border: "1px solid #cbc1c157",
        boxShadow: '3px 3px 3px #cbc1c157',
        height: "100%",
    },
    buttonClose: {
        display: 'flex',
        gap: 4,
        alignItems: 'center',
        '& .MuiIconButton-root': {
            padding: 3,
            margin: 0,
            '& svg': {
                fontSize: 22,
            },
        },
    },
    title: {
        color: theme.palette.grey.hairline,
        fontSize: theme.spacing(2.2),
        margin: theme.spacing(1.5, 0, 1, 3),
        fontWeight: '600',
        textOverflow: "ellipsis",
        overflow: "hidden",
        whiteSpace: "nowrap",
    },
    animationCut: {
        backgroundColor: `${"#ebebeb"}`,
        borderStyle: "dashed",
        borderColor: "#7e7979",
        borderWidth: "2px",
    },
    emptyCOnfig: {
        fontSize: theme.spacing(2),
        color: "#3c2d43",
        height: '70%',
        alignItems: 'center',
        display: "flex",
        justifyContent: "center"
    }
}));

export default function ShowcaseLayout({
    stateData, setStateData, edit, setEdit, setClose,
    setMsg, togglePanel, setComponentState, refresh, editFunctionImg, setStateDataComponentsImageZoom, realTimeData, resAutomateList, disabledButtonEdit, setDisabledButtonEdit
}) {
    const classes = useStyles();
    const TOOLTIP_TEXT = {
        DELETE: "Elimina su componente.",
        EDIT: "Permite editar su componente.",
    }
    const [positionsAux, setPositionsAux] = useState([])

    useEffect(() => {
        setComponentState(stateData.positions)
        setPositionsAux(stateData.positions)
        // eslint-disable-next-line 
    }, [])

    const onLayoutChange = (layout) => {
        setComponentState(layout)
        setPositionsAux(layout)
    }

    const deleteBox = (idx) => {
        if (stateData.positions.length > 1) {
            let componentsAux = [...stateData.components]
            let positionsAuxFuncition = positionsAux
            componentsAux.splice(idx, 1)
            positionsAuxFuncition.splice(idx, 1)
            positionsAuxFuncition.map((elem, index) => {
                elem.i = index.toString()
                return elem
            })
            componentsAux.map((elem, index) => {
                elem.indexBox = index
                return elem
            })
            setStateData({
                ...stateData,
                components: componentsAux,
                positions: positionsAuxFuncition
            })
        }
        else {
            setClose(true)
            setMsg({
                msg: "No puede tener menos de un componente",
                type: "error"
            })
        }
    }

    const checkComponentShowTitle = (element) => {
        if (element?.name === OPTIONS.editBlockDiagram || element?.name === OPTIONS.showBlockDiagram || element?.name === OPTIONS.labelComponent) {
            return false
        }
        else {
            return true
        }
    }

    const CreateDom = () => {
        let res = stateData?.components?.map((element, index) => {
            let ind = index.toString()
            return (
                <Box className={edit ? classes.animationCut : classes.boxes} key={ind}>
                    <>
                        {edit &&
                            <Box display="flex" justifyContent="space-between" position={'absolute'} style={{
                                zIndex: 9999,
                                backdropFilter: 'blur(15px)',
                            }}>
                                <Box className={classes.buttonClose}>
                                    <Tooltip
                                        title={TOOLTIP_TEXT.EDIT}
                                        arrow
                                        placement="right"
                                    >
                                        <IconButton
                                            aria-label="open_edit_box"
                                            onClick={() => togglePanel(index)}
                                        >
                                            <DriveFileRenameOutlineIcon color="primary" fontSize="small" />
                                        </IconButton>
                                    </Tooltip>
                                    <Tooltip
                                        title={TOOLTIP_TEXT.DELETE}
                                        arrow
                                        placement="right"
                                    >
                                        <IconButton
                                            color="primary"
                                            aria-label="delete"
                                            onClick={() => deleteBox(index)}
                                        >
                                            <DeleteForeverIcon fontSize="small" />
                                        </IconButton>
                                    </Tooltip>
                                </Box>
                            </Box>
                        }
                        <Box height={checkComponentShowTitle(element) ? '90%' : '100%'}  >
                            {checkComponentShowTitle(element) &&
                                <Box className={classes.title}>
                                    {element?.title ? element?.title : "-"}
                                </Box>
                            }
                            {listComponent({
                                id: element.id,
                                nameComponent: element.name,
                                index,
                                nameDevice: element.nameDevice,
                                variable: element.variable,
                                config_key: element?.config_key,
                                content: element?.content,
                                color: element?.color,
                                min: element?.min,
                                max: element?.max,
                                positions: stateData.positions[element.indexBox],
                                refresh,
                                nodes: element.nodes,
                                img: element?.file_base64 || element?.file_url,
                                edit,
                                setEdit,
                                editFunctionImg,
                                positionsAux,
                                image_zoom: element?.image_zoom,
                                setStateData,
                                stateData,
                                setStateDataComponentsImageZoom,
                                filter_key: element?.filter_key,
                                indicator: element?.indicator,
                                realTimeData: realTimeData,
                                setClose: setClose,
                                setMsg: setMsg,
                                resAutomateList: resAutomateList,
                                disabledButtonEdit: disabledButtonEdit,
                                setDisabledButtonEdit: setDisabledButtonEdit
                            })}

                            {!element?.id && !element?.name &&
                                <Box className={classes.emptyCOnfig}>
                                    <p>
                                        + Agregar componente.
                                    </p>
                                </Box>
                            }
                        </Box>
                    </>
                </Box >
            )
        })
        return res
    }

    return (
        // 🆕 CONTENEDOR CON SCROLL HORIZONTAL
        <Box
            style={{
                width: '100%',
                overflowX: 'auto',   // habilita scroll horizontal
                overflowY: 'hidden',
            }}
        >
            {/* 🆕 ANCHO MÍNIMO DEL DASHBOARD (ajustá este valor a tu layout) */}
            <Box style={{ minWidth: 1500 }}>
                <ResponsiveReactGridLayout
                    onLayoutChange={onLayoutChange}
                    layouts={{ lg: stateData?.positions ? stateData?.positions : [] }}
                    // 🆕 Usamos solo un breakpoint para que no cambie la cantidad de columnas
                    breakpoints={{ lg: 0 }}
                    cols={{ lg: 12 }}
                >
                    {CreateDom()}
                </ResponsiveReactGridLayout>
            </Box>
        </Box>
    );
}
